import { authService } from '@/services/auth/authService';
import { config } from '@/utils/config';
import { createApiClient } from './createApiClient';

// In dev, use same-origin paths so Vite proxies /api → VITE_API_URL (avoids CORS).
const baseURL = import.meta.env.DEV ? '' : config.API_URL;

export const apiClient = createApiClient({
  baseURL,
  getToken: () => authService.getValidToken(),
  onAuthError: (error) => authService.handleApiAuthError(error),
  onAuthSuccess: () => authService.notifyRequestSucceeded(),
});
